/** angular */
import { Component, Inject } from '@angular/core';
import { DsLibSnackbarData } from './interfaces/ds-lib-snackbar-data.interface';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { NgxTranslateArgs } from '../../../../shared/interfaces/ngx-translate-args.interface';
import { DsLibSnackbarStates } from './enums/ds-lib-snackbar-states.enum';
import { TranslateService } from '@ngx-translate/core';
/** end angular */

/**
 * Snackbar displaying at the bottom of the screen for a given period of time.
 */
@Component({
  selector: 'ds-lib-snackbar',
  templateUrl: './ds-lib-snackbar.component.html',
  styleUrls: ['./ds-lib-snackbar.component.scss'],
})
export class DsLibSnackbarComponent {
  /**
   * Text displayed inside the snackbar
   */
  text: string;

  /**
   * Optional arguments for the ngx translate pipe.
   */
  translateArgs: NgxTranslateArgs;

  /**
   * Icon displayed according to the snackbar state.
   */
  icon: 'check_circle' | 'warning' | 'error';

  /**
   * Creates an instance of DsLibSnackbarComponent.
   *
   * @param snackRef the reference to a snack bar dispatched from the snack bar service.
   * @param data the data that was passed in to a snack bar.
   * @param translate the translate service.
   */
  constructor(
    public snackRef: MatSnackBarRef<DsLibSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) data: DsLibSnackbarData,
    private translate: TranslateService
  ) {
    if (data) {
      this.translateArgs = data.translateArgs || {};
      this.text = data.text ? this.translate.instant(data.text, this.translateArgs) : '';
      const state: DsLibSnackbarStates = data.state || DsLibSnackbarStates.PRIMARY;
      switch (state) {
        case DsLibSnackbarStates.PRIMARY:
          this.icon = 'check_circle';
          break;
        case DsLibSnackbarStates.ACCENT:
          this.icon = 'warning';
          break;
        case DsLibSnackbarStates.WARN:
          this.icon = 'error';
          break;
        default:
      }
    }
  }

  /**
   * Dismisses the snack bar.
   */
  dismiss(): void {
    this.snackRef.dismiss();
  }
}
